module.exports = __webpack_public_path__ + "img/settings.7644c811.svg";